module.exports = __webpack_public_path__ + "static/media/logo-black.9fc7e21d.svg";